export class ReasonDateRangeFilterDTO {
    constructor(
        public id: string,
        public startDate: string,
        public endDate: string
    ) { }
}
